import { render, staticRenderFns } from "./AddInsRoom.vue?vue&type=template&id=1e1dc653&scoped=true&"
import script from "./AddInsRoom.vue?vue&type=script&lang=js&"
export * from "./AddInsRoom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1dc653",
  null
  
)

export default component.exports